export type UpdateTicketResponse = {
  tcktId: string;
  updateDateTime: string;
};
